/* 
 * Export component file to be used on project
*/

import Footer from './Footer';
export default Footer;
